import { useFeatureFlagVariantKey, useFeatureFlagPayload } from "posthog-js/react";
import { FEATURE_FLAGS } from "./feature-flags";
import { useEffect, useState } from "react";
import posthog from "posthog-js";

export function useLoadingFeatureFlagEnabled(
  flag: FEATURE_FLAGS,
  { variantKey, forceEnabled }: { forceEnabled?: boolean; variantKey?: boolean | string } = {},
) {
  const flagVariant = useFeatureFlagVariantKey(flag);
  const payload = useFeatureFlagPayload(flag);
  const [isPending, setIsPending] = useState(true);

  useEffect(() => {
    // For server-side rendering, we consider the flag  pending until the client-side rendering is complete
    setIsPending(false);
  }, []);

  useEffect(() => {
    posthog.capture("$feature_flag_called", {
      $feature_flag: flag,
      $feature_flag_response: flagVariant,
    });
  }, [flagVariant, flag]);

  if (forceEnabled)
    return {
      enabled: true,
      isPending: false,
      payload,
    };

  return {
    enabled: flagVariant === variantKey || flagVariant === true,
    isPending,
    payload,
  };
}
